/**
 * Validation messages for user-related inputs.
 * @typedef {Object} UserValidationMessages
 * @property {string} fullName - Validation message for first name field when it's empty.
 * @property {string} displayName - Validation message for display name field when it's empty.
 * @property {string} validFullName - Validation message for first name field when it's not valid.
 * @property {string} maxFullname - Validation message for first name field when it exceeds the character limit.
 */

/**
 * User Validation Messages.
 * @type {UserValidationMessages}
 */
export const validation = {
  fullName: "Please enter your first name",
  lastName: "Please enter your last name",
  displayName: "Please enter your display name",
  validFullName: "Please enter valid first name",
  validLastName: "Please enter valid last name",
  maxFullname: "First name should not be more than 20 characters",
  maxLastname: "Last name should not be more than 20 characters",
};
